import { node as coordination } from "src/modules/ltx/forms/coordination";
import { node as greenLight } from "src/modules/ltx/forms/greenLight";
import { node as patientCondition } from "src/modules/ltx/forms/patientCondition";
import { node as patientConditionReport } from "src/modules/ltx/forms/patientConditionReport";
import { node as patientStatementOfConsentTimm } from "src/modules/ltx/forms/patientStatementOfConsentTimm";
import { node as phaseI } from "src/modules/ltx/forms/phase-i";
import { node as phaseII } from "src/modules/ltx/forms/phase-ii";
import { node as scores } from "src/modules/ltx/forms/scores";
import { LeafNode, ParentNode } from "src/modules/shared/form-explorer";

export const forms: (ParentNode | LeafNode)[] = [
	phaseI,
	phaseII,
	scores,
	greenLight,
	patientCondition,
	patientConditionReport,
	coordination,
	patientStatementOfConsentTimm
];
